import type { Comment } from '.';
import { ButtonConfirm } from "core/components/form-controls";
import CToast from "core/components/CToast";
import { useUser } from "modules/Auth/hooks";
import { useDeleteComment } from './../../hooks';
import { _t } from "core/language";

const CommentItemDelete = ({ comment, isShow }: { comment: Comment, isShow: boolean }) => {
  const { userInfo } = useUser();
  const { user } = comment;
  const { deleteComment } = useDeleteComment();

  const onDelete = () => {
    if (comment) {
      deleteComment(comment.post_id, comment.id);
      CToast(_t("comunity.comment.delete_success"))
    }
  }

  if (!userInfo?.id) {
    return null;
  }

  return userInfo?.id === user?.id ? (
    <div className={`flex justify-end ${!isShow ? 'hidden' : ''}`}>
      <ButtonConfirm
        label={_t("comunity.comment.delete")}
        handleSubmit={onDelete}
        submitText={_t("comunity.text_yes")}
        closeText={_t("comunity.text_no")}
        message={_t("comunity.comment.delete_confirm")}
      >
        <label className="text-[12px] text-[#777777]">
          {_t("comunity.comment.delete")}
        </label>
      </ButtonConfirm>
    </div>
  ) : null;
}

export default CommentItemDelete;
